// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"89":"a92b6404","97":"4dc83a27","204":"9d335267","280":"9ec2a6c3","307":"fb2fac8f","343":"f87da2be","447":"08c152b5","487":"fb05dbb8","552":"00b82539","721":"2bc30b8f"}[chunkId] + ".chunk.css";
};